import { render, staticRenderFns } from "./deductions_dept.vue?vue&type=template&id=3a2892be"
import script from "./deductions_dept.vue?vue&type=script&lang=js"
export * from "./deductions_dept.vue?vue&type=script&lang=js"
import style0 from "./deductions_dept.vue?vue&type=style&index=0&id=3a2892be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports